import React from 'react';
import {Link} from 'react-router-dom'//yarn add @types/react-router-dom
import Paper from '@mui/material/Paper';
import Hidden from '@mui/material/Hidden';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import {Owner} from './Inc';
import Title from './Title';
import StoreImg from './StoreImg';
import useStyles from './Styles';

interface Props {
    owner:Owner,
    list:any[],
}

const TopSalesList:React.FC<Props> = (props)=> {
	const classes = useStyles();
	return (
        <Paper className={classes.paper} style={{marginBottom:"2em"}}>
            <Title text="売上履歴"/>
            <Table>
                <TableHead>
                    <TableRow style={{height:"2em"}}>
                        <TableCell className={classes.tableHeadNowrap}>受注日時</TableCell>
                        <Hidden smDown implementation="js">
                            <TableCell className={classes.tableHeadNowrap}>店舗</TableCell>
                        </Hidden>
                        <TableCell className={classes.tableHeadNowrap}>商品</TableCell>
                        <Hidden xsDown implementation="js">
                            <TableCell className={classes.tableHeadNowrap}>個数</TableCell>
                        </Hidden>
                        <Hidden smDown implementation="js">
                            <TableCell className={classes.tableHeadNowrap}>小計</TableCell>
                        </Hidden>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.list.map( (sales,index)=>{
                        const key = "sales"+index;
                        const badgeClass = "badge badgeStore"+sales.order_type_id;
                        return (
                    <TableRow key={key}>
                        <TableCell className={classes.tableCellNowrap}>{sales.order_date}<br/>{sales.order_time}</TableCell>
                        <Hidden smDown implementation="js">
                            <TableCell className={classes.tableCellNowrap}>
                                <span className={badgeClass}>{sales.store_name}</span>
                            </TableCell>
                        </Hidden>
                        <TableCell className={classes.tableCellDense}>
                            <div className="itemImgName">
                                <div className="img"><StoreImg owner_id={props.owner.owner_id} img_id={sales.img_id} className="imgList"/></div>
                                <div className="itemName">{sales.item_name}</div>
                            </div>
                        </TableCell>
                        <Hidden xsDown implementation="js">
                            <TableCell className={classes.tableCellNowrap} style={{textAlign:"right"}}>{sales.su}{sales.unit}</TableCell>
                        </Hidden>
                        <Hidden smDown implementation="js">
                            <TableCell className={classes.tableCellNowrap} style={{textAlign:"right"}}>{sales.shokei}円</TableCell>
                        </Hidden>
                    </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
            {props.owner.owner_id>0 &&
            <nav className={classes.more}>
                <Link to="/sale" className={classes.link}><ArrowForwardIcon/>売上履歴をもっと見る</Link>
            </nav>
            }
        </Paper>
    );
}

export default TopSalesList;
